"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // eslint-disable-next-line import/prefer-default-export


var StyledButton = (0, _styledComponents.default)(_Button.default).attrs({
  size: 'small'
}).withConfig({
  displayName: "styles__StyledButton",
  componentId: "guu1wo-0"
})(["width:", ";height:", ";margin:0 2.5px;border-radius:", ";"], (0, _rem.default)(26), (0, _rem.default)(26), (0, _rem.default)(14));
exports.StyledButton = StyledButton;